import Api from './api';

const PdvService = {
  cleanPdvCache: () => {
    sessionStorage.removeItem('pdv');
    sessionStorage.removeItem('vehiclesParked');
  },

  register: (params) => Api.post("/pdv/register", params, { headers: {'device': 'pdv'} }),

  activate: (params) => Api.post("/adm/pdv/activate", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  findBy: (key, value) => Api.get(`/adm/pdvs?limit=300&${key}=${value}`, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  selectUser: (pdv) => { sessionStorage.setItem('pdv', JSON.stringify(pdv)); },

  findByCpf: async (cpf) => { 
    const response = await Api.get(`/adm/pdvs?cpf_cnpj=${cpf}`, { headers: {'Authorization': sessionStorage.getItem('token')} });
    if (response.data.pdvs[0]) {
      sessionStorage.setItem('pdv', JSON.stringify(response.data.pdvs[0]));
      return true;
    } else {
      return false;
    }
  },

  edit: (params) => Api.post("/adm/pdv/edit", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  addCads: (params) => Api.post("/addCads", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  removeCads: (params) => Api.post("/removeCads", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  parkingHistory: (params) => Api.get(`/adm/historyParkings?cpf_cnpj=${params.cpf}&userType=2&limit=${params.limit}`, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  vehiclesParked: (cpf, isParked) => Api.get(`/adm/historyParkings?cpf_cnpj=${cpf}&userType=2&isParked=${isParked}`, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  transactionsHistory: (params) => Api.get(`/adm/boughtCADsHistory?cpf_cnpj=${params.cpf}&userType=2&limit=${params.limit}`, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  setAdmin: (params) => Api.post("/adm/user/setAdmin", params, { headers: {'Authorization': sessionStorage.getItem('token')} }),
}

export default PdvService;
